{
  "title": {
    "selectKind": "ยื่นอุทธรณ์",
    "details": "เหตุผลการอุทธรณ์",
    "amountMismatch": "จำนวนเงินไม่ตรงกัน"
  },
  "submitButton": {
    "selectKind": "ถัดไป",
    "details": "ยืนยัน",
    "amountMismatch": "ขอแก้ไขจำนวนเงิน"
  },
  "selectKind": {
    "title": "ประเภทการอุทธรณ์",
    "options": {
      "UploadPaymentProofFailed": "อัปโหลดรูปภาพไม่ได้",
      "BankInfoError": "โอนผ่านบัตรธนาคารไม่ได้",
      "WechatInfoError": "สแกนคิวอาร์โค้ด WeChat ไม่ได้",
      "AlipayInfoError": "สแกนคิวอาร์โค้ด Alipay ไม่ได้",
      "QQInfoError": "สแกนคิวอาร์โค้ด QQ ไม่ได้",
      "SellerDidNotConfirm": "ผู้ขายไม่ปล่อยเหรียญ",
      "CannotConfirmBuyerPaymentProof": "บัญชีรับเงินมีปัญหาและยืนยันไม่ได้",
      "AmountMismatch": "จำนวนเงินไม่ตรงกัน",
      "SellerNotReceivedPayment": "ยังไม่ได้รับเงิน",
      "Other": "อื่น ๆ"
    }
  },
  "details": {
    "title": "เหตุผลการอุทธรณ์",
    "placeholder": "กรอกเหตุผลการอุทธรณ์",
    "uploadImage": "อัปโหลดรูปภาพ",
    "uploadImageTip": "อัปโหลดรูปภาพ 1 ถึง 3 รูป แต่ละรูปต้องไม่เกิน 5MB รองรับ JPG, JPEG, PNG",
    "submitFailed": "ส่งไม่สำเร็จ",
    "maxCharacters": "จำนวนอักขระเกินขีดจำกัด 800 ตัว",
    "modal": {
      "title": "ยืนยันการยื่นอุทธรณ์",
      "content": "หลังยื่นอุทธรณ์ ฝ่ายสนับสนุนจะเข้ามาดูแลธุรกรรมนี้จนกว่าจะสิ้นสุด",
      "cancel": "ยกเลิก",
      "confirm": "ยืนยันการอุทธรณ์"
    }
  },
  "amountMismatch": {
    "description": "หากจำนวนเงินที่ได้รับไม่ตรงกับที่คาดไว้ โปรดกรอกจำนวนเงินจริงที่คุณได้รับด้านล่าง เมื่อผู้ซื้อยอมรับ คำสั่งซื้อจะเปลี่ยนเป็นจำนวนเงินที่คุณกรอก และปริมาณธุรกรรม {{token}} ที่เกี่ยวข้องจะได้รับการอัปเดต",
    "estimatedAmount": "คาดว่าจะได้รับ",
    "actualAmount": "ได้รับจริง",
    "placeholder": "กรอกจำนวนเงินที่ขอแก้ไข",
    "uploadImage": "อัปโหลดหลักฐานการทำรายการ",
    "uploadImageTip": "อัปโหลดรูปภาพ 1 ถึง 3 รูป แต่ละรูปต้องไม่เกิน 5MB รองรับ JPG, JPEG, PNG",
    "amountExceedsRemaining": "จำนวนเงินที่เพิ่มเกินจำนวนคงเหลือของรายการเดิม โปรดกรอกใหม่",
    "changeInProgress": "มีคำสั่งซื้ออื่นใต้รายการขายเดียวกันกำลังแก้ไขจำนวนเงิน จึงยังแก้ไขจำนวนเงินของคำสั่งซื้อนี้ไม่ได้ โปรดลองใหม่ภายหลัง",
    "exceedsOriginal": "หากจำนวนที่ต้องการแก้ไขเกินจำนวนธุรกรรมเดิม โปรดยื่นอุทธรณ์",
    "limitTitle": "ข้อจำกัดการแก้ไขจำนวนเงิน"
  },
  "back": "ก่อนหน้า",
  "SellerNotReceivedPayment": {
    "description": "โปรดบันทึกและอัปโหลดวิดีโอรายการเดินบัญชีธนาคาร โดยต้องแสดงเวลาปัจจุบันอย่างชัดเจน\nคุณสามารถทำตามขั้นตอนนี้: เปิดร้านแอป > ค้นหาและเปิดแอปธนาคาร > ข้อมูลบัตร > รายการเดินบัญชี"
  }
}
